import { create } from "zustand";
import { ApiAuth } from "@/shared/api/auth/api-auth";
import { type UserProfile } from "@/shared/api/types";

interface AuthState {
  profile: UserProfile | null;
  isLoading: boolean;
  isAdmin: () => boolean;
  authenticate: () => Promise<void>;
  refetchProfile: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  profile: null,
  isLoading: true,

  isAdmin: () => get().profile?.role === "ADMIN",

  authenticate: async () => {
    set({ isLoading: true });
    const authApi = new ApiAuth();
    const initData = window.Telegram?.WebApp?.initData;

    try {
      if (initData) {
        await authApi.loginWithTelegram(initData);
        const response = await authApi.getProfile();
        set({ profile: response.data });
      } else {
        console.warn("Telegram WebApp initData is missing.");
        set({ profile: null });
      }
    } catch (error) {
      console.error("Authentication process failed", error);
      set({ profile: null });
    } finally {
      set({ isLoading: false });
    }
  },

  refetchProfile: async () => {
    const authApi = new ApiAuth();
    try {
      const response = await authApi.getProfile();
      set({ profile: response.data });
    } catch (error) {
      console.error("Refetching profile failed", error);
      set({ profile: null });
    }
  },
}));
